export const DEFAULT_PRIMARY = '263.4 70% 50.4%';

export type ThemeColors = { primary?: string | null };

export function parseThemeColors(raw: unknown): ThemeColors | null {
  if (raw == null) return null;
  let value: unknown = raw;
  if (typeof raw === 'string') {
    try {
      value = JSON.parse(raw);
    } catch {
      return null;
    }
  }
  if (!value || typeof value !== 'object') return null;
  const primary = (value as ThemeColors).primary;
  if (primary == null || primary === '') return { primary: null };
  if (typeof primary !== 'string') return null;
  return { primary: primary.trim() };
}

export function resolvePrimaryHsl(themeColors?: ThemeColors | null): string {
  const primary = themeColors?.primary?.trim();
  return primary || DEFAULT_PRIMARY;
}

export function toCssHsl(themeColors?: ThemeColors | null): string {
  return `hsl(${resolvePrimaryHsl(themeColors)})`;
}

export function applyBrandPrimary(primary: string | null | undefined) {
  if (typeof document === 'undefined') return;
  const value = primary?.trim() || DEFAULT_PRIMARY;
  const root = document.documentElement;
  root.style.setProperty('--primary', value);
  root.style.setProperty('--ring', value);
}

export function applyThemeColors(themeColors?: ThemeColors | null) {
  applyBrandPrimary(themeColors?.primary);
}
